module.exports = __webpack_public_path__ + "img/KS.e8f980f6.svg";